module.exports = __webpack_public_path__ + "static/media/bg.f2e133b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/components/Main/bg.jpg
// module id = 117
// module chunks = 0